import classnames from "classnames";
import kebabCase from "lodash/kebabCase";

type Modifiers = Record<string, unknown>;

class Bem {
  private name: string;
  private modifierArray: string[] = [];
  private literalClassNames: string[] = [];

  constructor(name: string) {
    this.name = name;
  }

  className = () => {
    return classnames(
      this.name,
      ...this.literalClassNames,
      ...this.modifierArray
    );
  };

  toString = () => {
    return this.className();
  };

  literal = (literal?: string) => {
    if (literal) {
      this.literalClassNames = this.literalClassNames.concat(literal);
    }
    return this;
  };

  modifiers = (modifiers: Modifiers) => {
    this.modifierArray = this.modifierArray.concat(
      Object.keys(modifiers)
        .filter((key) => modifiers[key])
        .map((key) => {
          return `${this.name}--${kebabCase(key)}`;
        })
    );

    return this;
  };

  element = (
    elem: string,
    literalOrModifiers?: string | Modifiers,
    modifiers?: Modifiers
  ) => {
    const bem = new Bem(`${this.name}__${elem}`);

    // If second argument is a string, treat it as literal
    if (typeof literalOrModifiers === "string") {
      bem.literal(literalOrModifiers);
      if (modifiers) {
        bem.modifiers(modifiers);
      }
    }
    // If second argument is an object, treat it as modifiers
    else if (literalOrModifiers && typeof literalOrModifiers === "object") {
      bem.modifiers(literalOrModifiers);
    }

    return bem.className();
  };
}

export const componentName = (name: string) => {
  return new Bem(name);
};
